module.exports = __webpack_public_path__ + "static/media/ms-marvel-vol5-super-famous.adac3274.jpg";